
export const FormViewerActionTakenDisplays = {
  NoDisplay: 0,
  OptedOut: 1,
  SaveAsDraft: 2,
  Completed: 3,
}

export const ParticipantStatuses = {
  NotStarted: 1,
  InProgress: 2,
  Rescinded: 3,
  Declined: 4,
  Completed: 5,
  Closed: 6,
}

export const TalentFormFormTypes = {  
  PeerFeedback: 1,
  Recruiting: 2,
  Surveys: 3,
}
